export default function(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-interpolate/src/number.js
// module id = 62
// module chunks = 0